var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "payment",
      attrs: {
        id: "modalWindow",
        centered: "",
        title: "Подтверждение",
        "ok-only": true,
        "ok-disabled": !!_vm.discount && !_vm.comment,
        "ok-title": "Подтвердить внесённую оплату"
      },
      on: { ok: _vm.finalConfirmOrder }
    },
    [
      _vm.order !== null
        ? _c(
            "div",
            [
              _c("h5", [
                _vm._v(
                  "Сумма: " +
                    _vm._s(_vm.sumPrice()) +
                    " " +
                    _vm._s(
                      _vm.discount > 0
                        ? " - " + _vm.discountPrice + " = " + _vm.realPrice
                        : ""
                    ) +
                    " ₽"
                )
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("h5", [_vm._v("Наличные")]),
              _vm._v(" "),
              _c(
                "b-input-group",
                { staticClass: "mt-3" },
                [
                  _c("b-form-input", {
                    class: { nonActive: _vm.valueCash === 0 },
                    attrs: {
                      type: "number",
                      placeholder: "Наличные",
                      value: _vm.valueCash
                    },
                    on: {
                      input: function($event) {
                        _vm.changeValue($event, _vm.TYPE_PAYMENT.CASH)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-input-group-append",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "success" },
                          on: { click: _vm.sumCash }
                        },
                        [_vm._v("Вся сумма")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("h5", [_vm._v("По карте")]),
              _vm._v(" "),
              _c(
                "b-input-group",
                { staticClass: "mt-3" },
                [
                  _c("b-form-input", {
                    class: { nonActive: _vm.valueCard === 0 },
                    attrs: {
                      type: "number",
                      placeholder: "По карте",
                      value: _vm.valueCard
                    },
                    on: {
                      input: function($event) {
                        _vm.changeValue($event, _vm.TYPE_PAYMENT.CARD_IN_PLACE)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-input-group-append",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "success" },
                          on: { click: _vm.sumCard }
                        },
                        [_vm._v("Вся сумма")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("h5", [_vm._v("Аванс")]),
              _vm._v(" "),
              _c("b-form-input", {
                attrs: { type: "number", placeholder: "Аванс", disabled: true },
                model: {
                  value: _vm.valueSberbank,
                  callback: function($$v) {
                    _vm.valueSberbank = $$v
                  },
                  expression: "valueSberbank"
                }
              }),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("h5", [_vm._v("По карте online")]),
              _vm._v(" "),
              _c("b-form-input", {
                attrs: {
                  type: "number",
                  placeholder: "По карте online",
                  disabled: true
                },
                model: {
                  value: _vm.valueCardOnline,
                  callback: function($$v) {
                    _vm.valueCardOnline = $$v
                  },
                  expression: "valueCardOnline"
                }
              }),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("h5", [_vm._v("Платежной ссылкой")]),
              _vm._v(" "),
              _c("b-form-input", {
                attrs: {
                  type: "number",
                  placeholder: "Платежной ссылкой",
                  disabled: true
                },
                model: {
                  value: _vm.valuePaymentLink,
                  callback: function($$v) {
                    _vm.valuePaymentLink = $$v
                  },
                  expression: "valuePaymentLink"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            title: "Неверное местоположение",
            "cancel-title": "Попробовать ещё раз",
            "ok-title": "Всё-равно продолжить",
            id: "modal-incorrect-geoposition"
          },
          on: { ok: _vm.openClicker }
        },
        [_vm._v("\n          Вы слишком далеко от адреса доставки\n        ")]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            title: "Ошибка определения местоположения",
            "ok-only": "",
            "ok-title": "Всё-равно продолжить",
            id: "modal-enable-geopos"
          },
          on: { ok: _vm.openClicker }
        },
        [
          _vm._v(
            "\n          Пожалуйста, включите определение местоположения\n        "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            title: "Кликните " + _vm.rollsCount + " раз, чтобы продолжить",
            "ok-only": "",
            "ok-disabled": _vm.numberClicked < _vm.rollsCount,
            id: "modal-clicker"
          },
          on: {
            shown: _vm.startAnimation,
            ok: _vm.acceptOrder,
            hidden: _vm.stopAnimation
          }
        },
        [
          _c("hr"),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [
            _c("b", { staticClass: "numberClicker" }, [
              _vm._v(_vm._s(_vm.numberClicked))
            ])
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("div", { on: { click: _vm.increaseClick } }, [
            _c("img", {
              staticClass: "w-100 px-3 mainImage",
              style: {
                transform:
                  "scale(" +
                  _vm.iconCurrentSize +
                  ", " +
                  _vm.iconCurrentSize +
                  ")"
              },
              attrs: {
                src: "/static/rollClicker.png",
                alt: "Ролл, на который нужно кликать"
              }
            })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c63f8d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c63f8d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalPaymentInfo.vue
// module id = null
// module chunks = 